import {
  dateOperating
} from '@/cllib/tools'

import {
  distributionGetData,
  distributionWriteoffUpdate
} from '@/api/api'

let statusTextMap = {
  way: '在途',
  plan: '计划',
  end: '入库'
}

let dcopy = require('deep-copy')

const state = {
  writeoffDistribution: [],
  writeoffDistributionLoading: false,
  updateWriteoffDistribution: {},
  updateWriteoffDistributionNotNull: false
}

const getters = {
  writeoffDistribution: state => state.writeoffDistribution,
  writeoffDistributionLoading: state => state.writeoffDistributionLoading,
  updateWriteoffDistribution: state => state.updateWriteoffDistribution,
  updateWriteoffDistributionNotNull: state => state.updateWriteoffDistributionNotNull
}

const actions = {
  loadWriteoffDistribution ({ dispatch, getters }) {
    dispatch('setUpdateWriteoffDistribution', {})
    dispatch('setUpdateWriteoffDistributionNotNull', false)
    if (!getters.chooseWriteoffInvoicing.id) {
      dispatch('setWriteoffDistribution', [])
      return
    }
    dispatch('setWriteoffDistributionLoading', true)
    let chooseWriteoffInvoicingCollectTime = getters.chooseWriteoffInvoicingCollectTime
    let parm = {
      noPage: 1,
      gasTankId: getters.chooseWriteoffInvoicing.gasTankId,
      planTime: dateOperating.computeDay({days: -10, date: chooseWriteoffInvoicingCollectTime, format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 5, date: chooseWriteoffInvoicingCollectTime, format: 'yy-mm-dd'})
    }
    distributionGetData(parm).then((data) => {
      data.forEach((item) => {
        item.planTimeS = item.planTime.slice(5, 10)
        item.planVolumeS = parseInt(item.planVolume)
        item.sendTimeS = item.sendTime ? item.sendTime.slice(5, 16) : '--'
        item.inTimeS = item.inTime ? item.inTime.slice(5, 16) : '--'
        item.statusText = statusTextMap[item.status]
        item.oilNameS = item.oilName.split('号')[0]
        item.tankMark = item.mergeTankMark ? (item.tankMark + '/' + item.mergeTankMark) : item.tankMark
      })
      dispatch('setWriteoffDistribution', data)
      dispatch('setWriteoffDistributionLoading', false)
    }).catch((e) => {
      dispatch('setWriteoffDistributionLoading', false)
    })
  },
  distributionWriteoffUpdate ({ commit, dispatch, getters }) {
    let distributions = []
    for (let key in getters.updateWriteoffDistribution) {
      distributions.push(getters.updateWriteoffDistribution[key])
    }
    distributionWriteoffUpdate({distributions}).then(() => {
      dispatch('showNoticeMsg', {type: 'success', title: '系统提示', message: '修改成功！'})
      dispatch('loadWriteoffInvoicingList')
      dispatch('loadWriteoffRelatedinvoicing')
      dispatch('loadWriteoffDistribution')
      dispatch('updateDwLoadPiTag')
    })
  },
  updateWriteoffDistributionOne ({ commit, dispatch, getters }, data) {
    dispatch('setUpdateWriteoffDistributionNotNull', true)
    let changeData = {
      new: {},
      his: {}
    }
    getters.writeoffDistribution.forEach((item) => {
      if (item.id === data.id) {
        changeData.his = {
          inTime: item.inTime,
          inVolume: item.inVolume,
          gasTankId: item.gasTankId
        }
      }
    })
    commit('updateWriteoffDistributionOne', data)
    getters.writeoffDistribution.forEach((item) => {
      if (item.id === data.id) {
        changeData.new = {
          inTime: item.inTime,
          inVolume: item.inVolume,
          gasTankId: item.gasTankId
        }
      }
    })
    dispatch('updateWriteoffRelatedInvoicingOne', changeData)
  },
  setWriteoffDistributionLoading ({ commit }, data) {
    commit('setWriteoffDistributionLoading', data)
  },
  setWriteoffDistribution ({ commit }, data) {
    commit('setWriteoffDistribution', data)
  },
  setUpdateWriteoffDistribution ({ commit }, data) {
    commit('setUpdateWriteoffDistribution', data)
  },
  setUpdateWriteoffDistributionNotNull ({ commit }, data) {
    commit('setUpdateWriteoffDistributionNotNull', data)
  }
}

const mutations = {
  setUpdateWriteoffDistributionNotNull (state, data) {
    state.updateWriteoffDistributionNotNull = data
  },
  setWriteoffDistributionLoading (state, data) {
    state.writeoffDistributionLoading = data
  },
  setWriteoffDistribution (state, data) {
    state.writeoffDistribution = data
  },
  setUpdateWriteoffDistribution (state, data) {
    state.updateWriteoffDistribution = data
  },
  updateWriteoffDistributionOne (state, data) {
    state.writeoffDistribution.forEach((item) => {
      if (item.id === data.id) {
        if (data.inTime) {
          item.inTime = dateOperating.formatDate({date: data.inTime, format: 'yy-mm-dd hh:mm:ss'})
          item.inTimeS = item.inTime ? item.inTime.slice(5, 16) : '--'
          item.loadVolume = item.loadVolume === null || !parseInt(item.loadVolume) ? item.planVolume : item.loadVolume
          item.inVolume = item.inVolume === null ? item.loadVolume : item.inVolume
          item.status = 'end'
        } else {
          item.inTime = null
          item.inTimeS = '--'
          item.inVolume = null
          item.status = item.loadVolume ? 'way' : 'plan'
        }
        item.statusText = statusTextMap[item.status]
        state.updateWriteoffDistribution['key_' + item.id] = dcopy(item)
        state.updateWriteoffDistribution['key_' + item.id].replaceUpdate = 0
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/distribution_writeoff/writeoff_distribution.js